export enum AddPaymentInfoEventPaymentTypes {
  APPLE_PAY = 'apple pay',
  GOOGLE_PAY = 'googlepay',
  PAYPAL = 'paypal',
}
